import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ContactHero from '../components/contact/ContactHero';
import ContactInfo from '../components/contact/ContactInfo';
import MapSection from '../components/contact/MapSection';
import ContactFAQ from '../components/contact/ContactFAQ';
import OfficeSchedule from '../components/contact/OfficeSchedule';

function ContactPage() {
  // Scroll to form if URL includes #form anchor
  useEffect(() => {
    if (window.location.hash === '#form') {
      const element = document.getElementById('form');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Contattaci | Agenzia Immobiliare Scandicci | Molinaro Immobiliare</title>
        <meta name="description" content="Contatta Molinaro Immobiliare a Scandicci per informazioni su immobili, consulenze personalizzate, valutazioni gratuite o per fissare un appuntamento con i nostri esperti." />
        <meta name="keywords" content="contatti agenzia immobiliare, appuntamento immobiliare Scandicci, valutazione immobile gratuita, contattare agente immobiliare scandicci, consulenza immobiliare" />
        <link rel="canonical" href="https://www.molinaroimmobiliare.it/contatti" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.molinaroimmobiliare.it/contatti" />
        <meta property="og:title" content="Contattaci | Agenzia Immobiliare Scandicci | Molinaro Immobiliare" />
        <meta property="og:description" content="Contatta Molinaro Immobiliare a Scandicci per informazioni su immobili, consulenze personalizzate, valutazioni gratuite o per fissare un appuntamento con i nostri esperti." />
        <meta property="og:image" content="https://www.molinaroimmobiliare.it/images/agenzia6.jpeg" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://www.molinaroimmobiliare.it/contatti" />
        <meta property="twitter:title" content="Contattaci | Agenzia Immobiliare Scandicci | Molinaro Immobiliare" />
        <meta property="twitter:description" content="Contatta Molinaro Immobiliare a Scandicci per informazioni su immobili, consulenze personalizzate, valutazioni gratuite o per fissare un appuntamento con i nostri esperti." />
        <meta property="twitter:image" content="https://www.molinaroimmobiliare.it/images/agenzia6.jpeg" />
        
        {/* Structured Data for Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "Molinaro Immobiliare",
            "image": "https://www.molinaroimmobiliare.it/logo_molinaro.png",
            "url": "https://www.molinaroimmobiliare.it",
            "telephone": "+39 327 8855115",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Via Pisana 327",
              "addressLocality": "Scandicci",
              "postalCode": "50018",
              "addressRegion": "FI",
              "addressCountry": "IT"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 43.756111,
              "longitude": 11.178889
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "18:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "09:00",
                "closes": "12:30"
              }
            ]
          })}
        </script>
      </Helmet>
      
      <div className="bg-white" id="page-top">
        <ContactHero />
        <div id="form">
          <ContactInfo />
        </div>
        <MapSection />
        <OfficeSchedule />
        <ContactFAQ />
      </div>
    </>
  );
}

export default ContactPage;